export default __webpack_public_path__ + "static/ArduinoNanoESP32-1fb877afe9d1258fd26c60a2b0d7de4f.svg";